module.exports = __webpack_public_path__ + "static/img/c22.009020f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c22.png
// module id = 269
// module chunks = 0 1 2 3 4 5 6 7 8 9